import AbstractChart from './AbstractChart';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from 'moment';
import { chartColorCode, labelColor } from './colorCodes';
import {
  CHART_BACKGROUND_COLOUR,
  DEFAULT_CHART_HEIGHT,
  DEFAULT_CHART_WIDTH,
  FILTER_DATE_RANGE_FORMAT,
  DEFAULT_TITLE_STYLE,
  DEFAULT_NO_DATA_OPTIONS,
  SERIES_KEY,
  TITLE_KEY,
  TEXT_KEY
} from './constants/HighchartsConstants';
import { renderChart } from './CommonChartMethods';

HighchartsMore(Highcharts);

class ColumnChart extends AbstractChart {
  constructor(props) {
    super(props);
    this.state = {
      mapDataFromProps: {},
      chartData: [],
      source: [],
      topicId: [],
      filterDateRange: {
        fromDate: moment().format(FILTER_DATE_RANGE_FORMAT),
        toDate: moment().format(FILTER_DATE_RANGE_FORMAT),
      },
      mapOptions: {
        chart: {
          type: 'column',
          backgroundColor: CHART_BACKGROUND_COLOUR,
          marginBottom: 60,
          width: DEFAULT_CHART_WIDTH,
          height: DEFAULT_CHART_HEIGHT,
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {
          enabled: false,
        },
        noData: {...DEFAULT_NO_DATA_OPTIONS},
        title: {...DEFAULT_TITLE_STYLE},
        tooltip: { enabled: false },
        credits: {
          enabled: false,
        },
        xAxis: {
          labels: {
            style: {
              color: '#999999',
              fontSize: '8px',
              lineHeight: '5px',
              textTransform: 'capitalize',
            },
          },
        },
        yAxis: {
          labels: {
            style: {
              fontSize: '8px',
            },
            y: 2,
          },

          tickInterval: 10,
          title: '',
        },
      },
    };
  }

  parseColumnChart = chart => {
    if (Object.keys(chart).length) {
      const updatedChart = chart['word'].map((item, index) => {
        return [item.replace('_', ' '), chart['freq'][index]];
      });
      return updatedChart;
    }
  };

  reRenderChartOnChange = props => {
    const { retrieveSelectedChartData } = this.props.actions;
    this.setState(
      {
        filterDateRange: props.dateRangeFilterValue,
        source: props.source,
        topicId: props.selectedTopicId,
      },
      () => {
        retrieveSelectedChartData({
          chartId: this.props.chartId.replace('chart', ''),
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
          source: this.state.source,
        });
      },
    );
  };

  componentDidMount() {
    this.reRenderChartOnChange(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { chartId, selectedTopicId, source } = this.props;
    if (
      JSON.stringify(newProps.ColumnChart[chartId]) !==
        JSON.stringify(this.state.mapDataFromProps) &&
      newProps.selectedTopicId != null
    ) {
      this.setState({ chartData: [] });
      const { title } = this.props;
      let { mapOptions } = this.state;
      const chartData = this.parseColumnChart(newProps.ColumnChart[chartId]);
      mapOptions[SERIES_KEY] = [
        {
          data: chartData,
          color: chartColorCode[title.split(' ')[title.split(' ').length - 2].toLowerCase()],
          dataLabels: {
            enabled: true,
            rotation: 360,
            align: 'center',
            format: '{point.y: f}',
            y: -4,
            style: {
              color: labelColor[title.split(' ')[title.split(' ').length - 2].toLowerCase()],
              fontSize: '8px',
              fontWeight: 'normal',
              textOutline: 0,
            },
          },
        },
      ];
      mapOptions['xAxis']['categories'] =
        chartData && chartData instanceof Array ? chartData.map(i => i[0]) : [];
      mapOptions[TITLE_KEY][TEXT_KEY] = this.props.title;
      this.setState({
        chartData,
        mapOptions,
        mapDataFromProps: this.props.ColumnChart[chartId],
        source,
      });
    }

    if (this._shouldReRenderChartBasedOnNewProps(newProps)) {
      this.reRenderChartOnChange(newProps);
    }
  }

  render() {
    const { mapOptions, mapDataFromProps } = this.state;
    return renderChart(mapOptions, mapDataFromProps);
  }
}

function mapStateToProps(state) {
  return {
    ColumnChart: state.charts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ColumnChart);



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/ColumnChart.js